/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * User roles
 */
export interface UserRole { 
    /**
     * User role id
     */
    id?: number;
    /**
     * User ID
     */
    userId?: number;
    /**
     * Organization unit ID
     */
    orgUnitId?: number;
    /**
     * User role
     */
    role?: RoleEnum;
    /**
     * User role grantor (user who approved this role)
     */
    grantorId?: number;
    /**
     * Start date
     */
    startDate?: Date;
    /**
     * End date
     */
    endDate?: Date;
    /**
     * The actual approving status
     */
    approvingStatus?: ApprovingStatusEnum;
}







export enum RoleEnum {
    Admin = 'admin',
    Producer = 'producer',
    Consumer = 'consumer',
    Professional = 'professional'
}








export enum ApprovingStatusEnum {
    WaitingForApproval = 'waiting_for_approval',
    ParticipantNewPassword = 'participant_new_password',
    Approved = 'approved',
    Rejected = 'rejected',
    PasswordChangeRequired = 'password_change_required'
}


